/* Practiko - avance automatico e infinito del carrusel "Tendencia ahora".
   DIR =  1: los productos se desplazan hacia la izquierda (entran por la derecha).
   DIR = -1: los productos se desplazan hacia la derecha (entran por la izquierda). */
(function(){
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SEL = '[id$="__product_list_tendencia"] slideshow-component.resource-list__carousel > slideshow-container > slideshow-slides';
  var DELAY = 3500;
  var DIR = 1;
  function init(){
    document.querySelectorAll(SEL).forEach(function(s){
      if (s.dataset.pkAuto) return;
      s.dataset.pkAuto = '1';
      var originals = Array.prototype.slice.call(s.children);
      if (originals.length < 2) return;
      var firstClone = null;
      originals.forEach(function(el){
        var c = el.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.removeAttribute('id');
        c.querySelectorAll('[id]').forEach(function(n){ n.removeAttribute('id'); });
        c.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(function(n){ n.setAttribute('tabindex', '-1'); });
        s.appendChild(c);
        if (!firstClone) firstClone = c;
      });
      var root = s.closest('.shopify-section') || s;
      var paused = false, resume;
      function pause(){ paused = true; clearTimeout(resume); }
      function play(ms){ clearTimeout(resume); resume = setTimeout(function(){ paused = false; }, ms || 0); }
      root.addEventListener('pointerenter', pause);
      root.addEventListener('pointerleave', function(){ play(800); });
      root.addEventListener('focusin', pause);
      root.addEventListener('focusout', function(){ play(800); });
      root.addEventListener('touchstart', pause, {passive:true});
      root.addEventListener('touchend', function(){ play(5000); }, {passive:true});
      function loopWidth(){
        return firstClone.getBoundingClientRect().left - originals[0].getBoundingClientRect().left;
      }
      function wrap(){
        var w = loopWidth();
        if (w <= 0) return;
        if (s.scrollLeft >= w - 2) s.scrollTo({left: s.scrollLeft - w, behavior: 'instant'});
        else if (DIR < 0 && s.scrollLeft <= 2) s.scrollTo({left: s.scrollLeft + w, behavior: 'instant'});
      }
      s.addEventListener('scroll', function(){ clearTimeout(s._pkW); s._pkW = setTimeout(wrap, 150); }, {passive:true});
      setInterval(function(){
        if (paused || document.hidden) return;
        var r = s.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        wrap();
        var step = originals[1].getBoundingClientRect().left - originals[0].getBoundingClientRect().left;
        s.scrollBy({left: DIR * step, behavior: 'smooth'});
      }, DELAY);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
